import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import AddTemplateToClass from '../../Modals/ConfirmationEmail/AddTemplateToClass'
import { creationClassStore } from 'state/class/classCreationStore'

const ConfirmationEmail: React.FC = () => {
  const [openEmailModal, setOpenEmailModal] = useState<boolean>(false)
  const classData = creationClassStore(store => store.classData)
  
  return (
    <>
      <div onClick={() => setOpenEmailModal(true)}>
        <IconsTextNavigation
          iconName="EnvelopeSimple"
          heading="Scheduled email"
          isCompleted={classData?.emailTemplates?.length || 0}
        />
      </div>
      {openEmailModal && (
        <AddTemplateToClass
          openModal={openEmailModal}
          closeModal={setOpenEmailModal}
        />
      )}
    </>
  )
}

export default ConfirmationEmail
